import PropTypes from 'prop-types'
import React     from 'react'

interface TextBadgeProps
{
  children: any;
  color?: string;
  text?: string;
  textSize?: string;
  fontWeight?: string;
  classes?: string;
}

const TextBadge: React.FC<TextBadgeProps> = ( props: TextBadgeProps ): JSX.Element => {
  const backgroundColor: string = props.color ?? 'blue-primary'
  const textColor: string       = props.text ?? 'black'
  const textSize: string        = props.textSize ?? 'xxs'
  const fontWeight: string      = props.fontWeight ?? 'medium'
  const classes: string         = props.classes ?? ''

  const classString = `inline-flex items-center rounded-md bg-${ backgroundColor } p-1 whitespace-nowrap text-${ textSize } font-${ fontWeight } text-${ textColor } leading-none ${ classes }`

  return (
    <>
      <span className={ classString }>{ props.children }</span>
    </>
  )
}

TextBadge.propTypes = {
  children:   PropTypes.oneOfType( [
                                     PropTypes.arrayOf( PropTypes.node ),
                                     PropTypes.node
                                   ] ).isRequired,
  color:      PropTypes.string,
  text:       PropTypes.string,
  textSize:   PropTypes.string,
  fontWeight: PropTypes.string,
  classes:    PropTypes.string
}

export default TextBadge
